import { Card, Modal, Space } from '@procurify/ui'

import { Tabs } from '@webapp/core/components/Tabs'
import { CreateLegalEntityFormPresenter } from '@webapp/platform/legal-entities/features/create-legal-entity'
import { LegalEntityListPresenter } from '@webapp/platform/legal-entities/features/list-legal-entities/presenters/LegalEntityListPresenter'
import { useLegalEntityListFeatureSet } from './useLegalEntityListFeatureSet'

export const LegalEntityListFeatureSet = () => {
  const {
    state: { isActive, tabs, createModalStates },
    methods: {
      onAdd,
      closeCreateModal,
      handleCreateSuccess,
      onSelect,
      onDeactivate,
      onActivate,
    },
  } = useLegalEntityListFeatureSet()

  return (
    <>
      <Tabs>
        {tabs.map((tab) => (
          <Tabs.TabLink key={tab.to} to={tab.to}>
            {tab.label}
          </Tabs.TabLink>
        ))}
      </Tabs>

      <Card>
        <Card.Content>
          <LegalEntityListPresenter
            isActive={isActive}
            onAdd={onAdd}
            onSelect={onSelect}
            onDeactivate={onDeactivate}
            onActivate={onActivate}
          />
        </Card.Content>
      </Card>

      <Modal {...createModalStates} onClose={closeCreateModal} maxWidth='sm'>
        <Modal.Card>
          <CreateLegalEntityFormPresenter
            onCancel={closeCreateModal}
            onSuccess={handleCreateSuccess}
          />
        </Modal.Card>
      </Modal>

      <Space />
    </>
  )
}

LegalEntityListFeatureSet.displayName = 'LegalEntityListFeatureSet'
